import { SVGProps } from 'react';

export default function HivemapperPin(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      {...props}>
      <circle cx="37.0064" cy="37.3345" r="37.0064" fill="#2F7BED" />
      <path
        d="M29.3334 51.5178H39.6597L24.1653 42.2314L29.3334 51.5178Z"
        fill="white"
      />
      <path
        d="M49.95 28.2046L47.2966 23.4226H53.1776C52.8221 22.7811 52.31 22.2483 51.6929 21.8781C51.0757 21.508 50.3755 21.3135 49.6629 21.3144H46.1284L44.3661 18.1265C44.0036 17.4952 43.4886 16.9732 42.8721 16.6124C42.2556 16.2517 41.559 16.0646 40.8514 16.0697L43.8215 21.3761H38.4653L36.6139 24.6464C32.7752 23.9698 28.8291 24.5294 25.3055 26.2501C21.7818 27.9707 18.8494 30.77 16.9019 34.2721C16.2892 35.3853 15.7787 36.556 15.3772 37.7686H26.7629L42.1087 47.0241L47.7917 57.3079C48.5994 56.3542 49.3156 55.3209 49.9302 54.2228C51.8756 50.72 52.7428 46.683 52.4154 42.6535C52.088 38.624 50.5816 34.7951 48.0986 31.6806L49.95 28.2046ZM42.2473 41.9953L37.9109 39.3934L35.1783 37.748L30.7924 35.1154L33.1982 30.8064L44.673 37.6863L42.2473 41.9953Z"
        fill="white"
      />
    </svg>
  );
}
